import React from 'react';
import { Skeleton } from '@mui/material';

import './desktop-product-list-page-skeleton-style.scss';

import DesktopProductListSkeleton from '@src/componentsNew/Skeleton/desktop/components/DesktopProductListSkeleton';

import { SKELETON_COLOR } from "@src/utils/constants";

interface IProps {
  type: 'normal' | 'category' | 'brand';
  productCount: number;
}

const DesktopProductListPageSkeleton = ({ type, productCount }: IProps) => {
  return (
    <div id="desktop-product-list-page-skeleton-wrapper">
      <div className="desktop-product-detail-page-skeleton-content-wrapper">
        {
          type === 'brand' &&
          <Skeleton variant="rectangular" width="100%" style={{ backgroundColor: SKELETON_COLOR, height: 'unset', aspectRatio: '6/1' }} />
        }

        <div className="desktop-product-list-page-skeleton-top-area">
          <div className="skeleton-top-area-content-wrapper">
            <div className="sorting-skeleton-wrapper">
              <Skeleton variant="rectangular" width={190} height={40} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
              <Skeleton variant="rectangular" width={160} height={30} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
            </div>
            {
              type === 'category' &&
              <div className="category-list-skeleton-wrapper">
                {
                  Array.from({ length: 8 }).map((_, index) => (
                    <Skeleton key={index} variant="rectangular" width={108} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
                  ))
                }
              </div>
            }
          </div>

          <div className="divider" />
        </div>

        <div className="desktop-product-list-page-skeleton-main-area">
          <div className="filter-skeleton-wrapper">
            <Skeleton variant="rectangular" width={50} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />

            <div className="filter-option-skeleton-wrapper">
              <Skeleton variant="rectangular" width="100%" height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
              <Skeleton variant="rectangular" width={120} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
              <Skeleton variant="rectangular" width={120} height={20} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />
            </div>
          </div>

          <DesktopProductListSkeleton type='horizontal' count={productCount} hasPadding={true} />
        </div>
      </div>
    </div>
  );
};

export default DesktopProductListPageSkeleton;
